module.exports = __webpack_public_path__ + "img/3.fa6d0d9c.png";